import { InjectionToken } from '@angular/core';
import { AppConfig } from '@orion-platform/core';

export const APP_CONFIG = new InjectionToken<AppConfig>('appConfig');
